import { render } from "./Process.vue?vue&type=template&id=d3d83418&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d83418"]])

export default __exports__